/*globals $:false */
import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';

import { sprintf } from 'sprintf-js';

import tmpl from '../templates/definition.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// View to create and edit a definition
var DefinitionV = function(core, $container) {

    var $definitionContainer = $(".js-definition-builder", $container),
        $nameField,
        $descriptionField,
        $fieldsContainer;

    var _showDefinition = function(definition, readOnly) {
        definition.htmlEncodedName = utils.encodeHTML(definition.name);
        definition.htmlEncodedDescription = utils.encodeHTML(definition.description);

        var $definition = $(tmpl({ definition: definition, readOnly: readOnly}));
        core.translate("recordm.definition", $definition);

        $definitionContainer.html($definition);
        $definitionContainer.removeClass("hidden");

        // set references to important elements
        var $definitionHeaderContainer = $(".js-definition-info");
        $nameField = $(".js-definition-name input", $definitionHeaderContainer);
        $descriptionField = $(".js-definition-description input", $definitionHeaderContainer);

        $fieldsContainer = $(".js-root-fields", $container);


        if (readOnly) {
            // todo huma - this should be done in the template, but for now I will leave it here
            $definitionHeaderContainer.find("input[type='text']").attr("readonly", "readonly");
            $definitionHeaderContainer.find("input[type='checkbox']").attr("disabled", "disabled");
        }
    };

    var _clearErrors = function(){
        $definitionContainer
            .find(".control-group, .field").removeClass("error")
            .find(".js-error-msg, .field-errors").addClass("hidden").text("");
    };

    var _showErrors = function(errors) {
        _clearErrors();
        Object.keys(errors).forEach((key) => {
            if(["name", "description"].indexOf(key) >= 0){
                $definitionContainer.find('[data-prop="' + key + '"]')
                    .parents(".control-group").addClass("error")
                    .find(".js-error-msg").removeClass("hidden")
                    .html(errors[key]
                       .map((e) => (e.part ? `<code>${e.part}</code>:` : '') + e.errorMsg)
                       .join('<br/>')
                    );
            }
        });
    };

    // callbacks:
    //
    //  * `save`: Save this definition
    //  * `cancel`: Cancel the operation
    //  * `edit_states`: User asked for the edit states mode
    //  * `edit_files`: User asked for the edit files mode. The default mode.
    var _init = function (callbacks) {
        $container.on("click", ".js-save", function() {
            callbacks.save();
        });

        $container.on("click", ".js-save-and-full-index", function() {
            ConfirmDialog(core, {
                    message: sprintf(core.translateString('recordm.definition', 'definition.msg.confirm-full-index')),
                    confirmBtnLabel: core.translateString('recordm.definition', 'actions.save-and-full-index'),
                    confirmBtnClass: 'btn-warning'
                },
                {
                    requestConfirmed: function() {
                        callbacks.save(true);
                    }
                }
            );

        });

        $container.on("click", ".js-cancel", function() {
            callbacks.cancel();
        });

        $container.on("click", ".js-edit-states", function(){
            callbacks.edit_states();
        });
        $container.on("click", ".js-edit-fields", function(){
            callbacks.edit_fields();
        });

        //someday jone isto talvez devesse ser feito sem eventos.
        //ou, pelo menos, usando eventos locais a estes Presenters/Views
        $container.on("click", ".js-collapse", function() {
            core.publish("collapse-fields");
        });
        $container.on("click", ".js-expand", function() {
            core.publish("expand-fields");
        });
    };

    var _destroy = function() {
        $container.off("click", ".js-save");
        $container.off("click", ".js-save-and-full-index");
        $container.off("click", ".js-cancel");
        $container.off("click", ".js-collapse");
        $container.off("click", ".js-expand");
    };

    return {
        init: _init,

        showDefinition: _showDefinition,
        getFieldsContainer: function(){
            return $fieldsContainer;
        },

        updateModel: function(definitionM){
            var data = definitionM.data;

            data.name = $nameField.val();
            data.description = $descriptionField.val();
        },
        showErrors: _showErrors,

        destroy: _destroy
    }
};

export default DefinitionV;
